import { ChangeEvent, useCallback, useRef } from "react"
import { Typography } from "matsuri-ui"
import styled from "@emotion/styled"
import { blobToString, imageCompressToWebp } from "@/utils/image"
import TakePhotoIcon from "@/components/Icon/TakePhoto.svg"
import { useTranslation } from "@/hooks/useTranslation"

const Cover = styled.div`
    display: flex;
    justify-content: center;
    & > div {
        background-color: rgba(65, 65, 65, 0.8);
        width: 163px;
        height: 218px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        & > p {
            color: white;
        }

        & > img {
            width: 40%;
            height: auto;
            margin: 1rem;
        }
    }
`

export const TakePhotoCover = ({
    onChange,
    onBlob
}: {
    // 既存の dataURL コールバック（後方互換のため optional）。
    onChange?: (data: string, mimetype: string) => void
    // 即時アップロード用。圧縮済み Blob を直渡しし、dataURL 往復を避ける。
    onBlob?: (blob: Blob) => void
}) => {
    const { t } = useTranslation()
    const inputRef = useRef<HTMLInputElement>(null)
    const handleFileChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            const files = event.currentTarget.files
            if (!files?.[0]) return
            // 圧縮した Blob を onBlob に直渡し、もしくは dataURL に変換して onChange に渡す。
            // 受け側は dataURL の mime から元の Blob を再構築できる。
            imageCompressToWebp(files[0]).then(async blob => {
                onBlob?.(blob)
                if (onChange) {
                    const dataUrl = await blobToString(blob)
                    onChange(dataUrl, blob.type)
                }
                if (inputRef.current) {
                    inputRef.current.value = ""
                }
            })
        },
        [onChange, onBlob]
    )

    return (
        <label htmlFor="image-input">
            <Cover>
                <div>
                    <img src={TakePhotoIcon} />
                    <Typography>{t("写真をアップロード")}</Typography>
                </div>
            </Cover>
            <input
                id="image-input"
                ref={inputRef}
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                style={{ display: "none" }}
            />
        </label>
    )
}
